import React from 'react';

export class BankInfo extends React.Component{

    constructor(props){
        super(props);

        const {memberBank} = this.props;

        this.state = {
            benefName : '', 
            benefAddress : '' ,
            benefAccNum : '' , 
            benefBankName : '' , 
            benefBankAddress : '', 
            benefBankCity : '' , 
            benefBankCountry : '' , 
            benefSwiftCode : '', 
            notes :''
        }

        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount(){
        if(this.props.memberBank){
            
            this.setState({
                benefName : this.props.memberBank.benefName , 
                benefAddress : this.props.memberBank.benefAddress ,
                benefAccNum : this.props.memberBank.benefAccNum , 
                benefBankName : this.props.memberBank.benefBankName , 
                benefBankAddress : this.props.memberBank.benefBankAddress , 
                benefBankCity : this.props.memberBank.benefBankCity , 
                benefBankCountry : this.props.memberBank.benefBankCountry , 
                benefSwiftCode : this.props.memberBank.benefSwiftCode , 
                notes : this.props.memberBank.notes
            })
        }
    }

    componentWillReceiveProps(nextprops){

        if(nextprops != this.props && nextprops.memberBank){

            this.setState({
                benefName : nextprops.memberBank.benefName , 
                benefAddress : nextprops.memberBank.benefAddress ,
                benefAccNum : nextprops.memberBank.benefAccNum , 
                benefBankName : nextprops.memberBank.benefBankName , 
                benefBankAddress : nextprops.memberBank.benefBankAddress , 
                benefBankCity : nextprops.memberBank.benefBankCity , 
                benefBankCountry : nextprops.memberBank.benefBankCountry , 
                benefSwiftCode : nextprops.memberBank.benefSwiftCode , 
                notes : nextprops.memberBank.notes
            })
        }
    }
    
    handleChange(event){
        this.setState({
            [event.target.name] : event.target.value
        } , ()=> {
            this.props.handleMemberBankUpdate(this.state , this.props.iteration);
        })
    }

    render(){
        const { benefName , benefAddress , benefAccNum , benefBankName , benefBankAddress , 
            benefBankCity ,benefBankCountry , benefSwiftCode , notes } = this.state ; 

        const{ disableForm } = this.props;

        return (
            <React.Fragment>
                <div className="columns m-t-xs">
                    <div className="column is-6">
                        <label className="label is-small">Beneficiary name</label>
                        <input className="input" value={benefName} name="benefName" type="text" placeholder="beneficiary Name" onChange={this.handleChange} disabled={disableForm}/>
                    </div>
                </div>
                <div className="columns">
                    <div className="column is-12">
                        <label className="label is-small">Beneficiary Address</label>
                        <input className="input" value={benefAddress} name="benefAddress" type="text" placeholder="beneficiary Full Address" onChange={this.handleChange} disabled={disableForm}/>
                    </div>
                </div>
                <div className="columns">
                    <div className="column is-6">
                        <label className="label is-small">Beneficiary Acc. Num.</label>
                        <input className="input" value={benefAccNum} name="benefAccNum" type="text" placeholder="beneficiary Account Number (or IBAN)" onChange={this.handleChange} disabled={disableForm} />
                    </div>
                    <div className="column is-6">
                        <label className="label is-small">Beneficiary Bank Name</label>
                        <input className="input" value={benefBankName} name="benefBankName" type="text" placeholder="beneficiary Bank Name" onChange={this.handleChange} disabled={disableForm} />
                    </div>
                </div>
                
                <div className="columns">
                    <div className="column is-12">
                        <label className="label is-small">Beneficiary Bank Addr.</label>
                        <input className="input" value={benefBankAddress} name="benefBankAddress" type="text" placeholder="beneficiary Bank Address" onChange={this.handleChange} disabled={disableForm} />
                    </div>
                </div>

                <div className="columns">
                    <div className="column is-6">
                        <label className="label is-small">Beneficiary Bank City</label>
                        <input className="input" value={benefBankCity} name="benefBankCity" type="text" placeholder="beneficiary Bank City" onChange={this.handleChange} disabled={disableForm} />
                    </div>
                    <div className="column is-6">
                        <label className="label is-small">Beneficiary Bank Country</label>
                        <input className="input" value={benefBankCountry} name="benefBankCountry" type="text" placeholder="beneficiary Bank Country" onChange={this.handleChange} disabled={disableForm} />
                    </div>
                </div>

                <div className="columns">
                    <div className="column is-6">
                        <label className="label is-small">Beneficiary Swift Codes</label>
                        <input className="input" value={benefSwiftCode} name="benefSwiftCode" type="text" placeholder="beneficiary Bank Swift Code" onChange={this.handleChange} disabled={disableForm} />
                    </div>
                    <div className="column is-6">
                        <label className="label is-small">Notes</label>
                        <input className="input" value={notes} name="notes" type="text" placeholder="Notes" onChange={this.handleChange} disabled={disableForm} />
                    </div>
                </div>
            </React.Fragment>
        )
    }
}



// WEBPACK FOOTER //
// ./src/Views/ProfilePage/BankInfo.jsx